export default __webpack_public_path__ + "static/address-verification-1181235357186c058f2ac62180200573.png";